let useWorker = undefined;

export const isUseWorker = () => {
	if (useWorker === undefined) {
		const msg = "Use Worker not configured yet";
		console.error(msg);
		throw Error(msg);
	}
	return useWorker;
};

export const setUseWorker = (useWorkerParam: boolean) => {
	useWorker = useWorkerParam;
};
